import { Type } from '@angular/core';
import { Route, Routes } from '@angular/router';
import { DetermineMarketComponent } from '@shared/lib/components/determine-market.component';
import { PageNotFoundComponent } from '@shared/lib/modules/page-not-found/components/page-not-found.component';
import { MarketResolver } from '@usana/ux/markets/routing';
import { CmsTypeGuard } from './guards/cms-type.guard';

const SHARED_ROUTES: Route[] = [
  {
    path: 'opportunity',
    loadChildren: () =>
      import('@shared/lib/lazy-modules/opportunity/opportunity.module').then((m) => m.OpportunityModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'story',
    loadChildren: () => import('@shared/lib/lazy-modules/story/story.module').then((m) => m.StoryModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'dmca',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/dmca/dmca.module').then((m) => m.DmcaModule),
  },
  {
    path: 'terms',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/terms/terms.module').then((m) => m.TermsModule),
  },
  {
    path: 'terms-policies',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/policies/policies.module').then((m) => m.PoliciesModule),
  },
  {
    path: 'ctsca',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/ctsca/ctsca.module').then((m) => m.CtscaModule),
  },
  {
    path: 'privacy',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/privacy/privacy.module').then((m) => m.PrivacyModule),
  },
  {
    path: 'income',
    loadChildren: () => import('@shared/lib/lazy-modules/income/income.module').then((m) => m.IncomeModule),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/gdpr/gdpr.module').then((m) => m.GdprModule),
  },
];

function buildFinalRoutes(cmsComponent?: Type<unknown>): Route[] {
  const routes: Route[] = [];

  if (cmsComponent) {
    routes.push({
      path: '**',
      canMatch: [CmsTypeGuard],
      data: { cmsType: 'cms' },
      component: cmsComponent,
    });
  }

  routes.push({
    path: '**',
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
    component: PageNotFoundComponent,
  });

  return routes;
}

export function combineAppAndSharedRoutes(appRoutes: Routes, lastRoutes: Routes, cmsComponent?: Type<unknown>): Routes {
  return [
    {
      path: ':marketId',
      component: DetermineMarketComponent,
      resolve: {
        market: MarketResolver,
      },
      children: [...appRoutes, ...SHARED_ROUTES, ...lastRoutes, ...buildFinalRoutes(cmsComponent)],
    },
    // Handles /ux/dotcom/ (no marketId)
    {
      path: '',
      component: DetermineMarketComponent,
    },
  ];
}
